import baseAxios from "../core/api/axios/baseAxios";

export default class RoleService {
  /****************************
   *
   * getter services
   *
   ****************************/
  static async getRoles() {
    const res = await baseAxios.get("/v2/roles/all");
    return res?.data || res;
  }
  static async getClaims(type) {
    const res = await baseAxios.get(`/v2/claims/all?filter=${type}`);
    return res?.data || res;
  }

  /****************************
   *
   * creator services
   *
   ****************************/
  static async createRole(data) {
    const res = await baseAxios.post("/v2/roles/create", data);
    return res?.data || res;
  }

  /****************************
   *
   * update services
   *
   ****************************/
  static async updateRole({ data, roleId }) {
    const res = await baseAxios.put(`/roles/${roleId}`, data);
    return res?.data || res;
  }
  /****************************
   *
   * delete services
   *
   ****************************/
  static async deleteRole(roleId) {
    const res = await baseAxios.delete(`/roles/${roleId}`);
    return res?.data || res;
  }
}
